import React, { useEffect, useState } from "react";
import Modal from 'react-bootstrap/Modal';
import moment from "moment";
import SelectFiled from "../../common/textfield/SelectFiled";
import { useFormik } from "formik";
import * as Yup from "yup";
import { failed } from "../../common/Toastify";
import { checkSchedule, getSlots } from "../../apps/api/AppointmentRequests";
import { Col, Row } from "react-bootstrap";
import { Skeleton } from "@mui/material";
import { ViewDate } from "../../../utils/DateSupport";
import {getScheduleSlots} from "../../api/Schedule";
import { useSelector } from "react-redux";
import { validation, conditionalValidation } from "../../../utils/constants";
import {
    filterSlotsForSelectedDay,
    getDateKey,
    getScheduleDateOptions,
    sortSlotsByStart,
} from "../../../utils/ScheduleAvailabilitySupport";

export function ViewScheduleDayModal({ modalShow, handleShow, userID, }) {
    const [serviceCategory, setServiceCategory] = useState([]);
    const [reservedCategories, setReservedCategories] = useState ({})
    const [slotsLoading, setSlotsLoading] = useState(false);
    const [availableSlots, setAvailableSlots] = useState([]);
    const userOrg = useSelector((state) => state?.auth?.user?.organizations);
    const userOrgId = userOrg?.[0]?.id;

    const formik = useFormik({
        initialValues: {
            serviceCategory: "",
        },
        validationSchema: Yup.object({
            serviceCategory: conditionalValidation(
                Yup.string(),
                {
                    validation,
                    mandatory: true,
                    label: "Title"
                })
        }),
    });

    useEffect(() => {
        const selectedDayKey = getDateKey(modalShow);

        checkSchedule({ actorId: userID, date: moment(modalShow)?.utc().format("YYYY-MM-DDTHH:mm:ss") + "Z", orgId: userOrgId})
            .then((res) => {
                if(!res?.data) {
                    failed(res?.message);
                    return;
                }

                let serviceCategoriesList = [];
                if (!Array.isArray(res.data)) res.data = [res.data];
                
                res.data.forEach(schedule => {
                    serviceCategoriesList.push(...schedule.serviceCategory?.filter(categoryData => 
                        getDateKey(categoryData?.date, getScheduleDateOptions(categoryData?.date)) === selectedDayKey
                           && !serviceCategoriesList.some(item => item.value === categoryData.id)
                            )?.map(categoryData => 
                            ({...categoryData, value: categoryData?.id})
                    ))                        
                })
                
                let reservedSlots ={}
                let newData = [];
                    
                res.data.forEach(schedule => 
                    getScheduleSlots(schedule.id, "busy-reserved", userOrgId)
                    .then((resp) =>{
                        (resp.data || [])
                        .forEach((slot) => {
                            let serviceCategoryId = slot?.serviceCategory?.[0]?.id || slot?.serviceCategory?.[0]?.coding?.[0]?.code
                            let categoryDate = schedule.serviceCategory?.find((item) => item.id === serviceCategoryId)?.date;
                            if (getDateKey(slot?.start, getScheduleDateOptions(categoryDate)) !== selectedDayKey) return;
                            
                            if (reservedSlots.hasOwnProperty(serviceCategoryId)) {
                                 reservedSlots[serviceCategoryId].push({
                                    "start": slot?.start,
                                    "end": slot?.end,
                                    "id": slot?.id,
                                    "categoryDate": categoryDate,
                                    "serviceCategory": slot.serviceCategory,
                                    "status": "busy-reserved"
                                });
                            }    
                            else {
                                reservedSlots[serviceCategoryId] = [{
                                    "start": slot?.start,
                                    "end": slot?.end,
                                    "id": slot?.id,
                                    "categoryDate": categoryDate,
                                    "serviceCategory": slot.serviceCategory,
                                    "status": "busy-reserved"
                                }];
                            }
                        })

                        Object.keys(reservedSlots).forEach(key => {
                            if (newData.some((item) => item.value === `${key}-busyReserved`)) return;
                            newData.push({
                                name: `Reserved for ${reservedSlots[key]?.[0]?.serviceCategory[0]?.name || reservedSlots[key]?.[0]?.serviceCategory[0]?.coding?.[0]?.display}`,
                                value: `${key}-busyReserved`,
                                date: reservedSlots[key]?.[0]?.categoryDate || reservedSlots[key]?.[0]?.start,
                                status: "busy-reserved"
                            });
                            
                        });
                        setReservedCategories(reservedSlots);
                        setServiceCategory([...serviceCategoriesList, ...newData])
                        handleServiceCategory({ target: { value: serviceCategoriesList?.[0]?.id } })
                    })
                    .catch((res) => {
                        failed(res?.response?.data?.message || res?.response?.data?.error || res.message);
                    })
                );

            })
            .catch((res) => {
                failed(res?.response?.data?.message || res?.response?.data?.error || res?.message);
            });
    }, [])

    const sortedObj = data => {
        return data.sort((a,b) => {
            return a.name > b.name ? 1 : -1
        });
    }

    const handleServiceCategory = (event) => {
        event && formik.setFieldValue("serviceCategory", event?.target?.value);
        setSlotsLoading(true)
        let targetVal = event?.target?.value;
        const selectedCategory = serviceCategory.find(
            (item) => item.value === targetVal || item.value === `${targetVal}-busyReserved`
        );
        const scheduleDateOptions = getScheduleDateOptions(selectedCategory?.date);
        if(targetVal?.endsWith("busyReserved")){
            let slots = reservedCategories[event?.target?.value.replace(/-busyReserved$/, "")] || [];
            slots = filterSlotsForSelectedDay(slots, getDateKey(modalShow), { options: scheduleDateOptions });
            slots = sortSlotsByStart(slots)
                //.filter(slot => moment(slot.start).isAfter(currentTime))
                //.sort((a, b) => moment(a.start).diff(moment(b.start)));
    
            setAvailableSlots(slots)
            setSlotsLoading(false)
        }else if(targetVal) {
            getSlots({ actorId: userID, date: moment(modalShow).utc().format("YYYY-MM-DDTHH:mm:ss") + "Z", serviceCategoryId: event?.target?.value || "default", orgId: userOrgId })
                .then((res) => {
                    let slots = filterSlotsForSelectedDay(res?.data?.availableSlots || [], getDateKey(modalShow), {
                        options: scheduleDateOptions,
                    });
                    slots = sortSlotsByStart(slots);
                    setAvailableSlots(slots)
                }).catch((res) => {
                    failed(res?.response?.data?.message || res?.response?.data?.error || res?.message);
                }).finally(() => { setSlotsLoading(false) })
        }
        else setSlotsLoading(false)
    };

    return (
        <>
            <Modal
                size="md" show={modalShow}
                onHide={handleShow}
                aria-labelledby="contained-modal-title-vcenter"
                backdropClassName
                backdrop={'static'}
                centered className="custom-dialog">
                <Modal.Header closeButton className="border-0">
                    <Modal.Title id="contained-modal-title-vcenter" style={{ textTransform: "capitalize" }}>
                        {ViewDate(modalShow)}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="common-form border-fields" onSubmit={formik.handleSubmit}>
                        <SelectFiled keyField={"serviceCategory"} label={"Select Service Category"} formik={formik} options={sortedObj(serviceCategory)} onChange={handleServiceCategory} />

                        {serviceCategory?.length > 0 && availableSlots?.length > 0 ?
                            <>
                                <Row>
                                    <Col>Select Slot</Col>
                                </Row>
                                <Row style={{ justifyContent: "center", rowGap: "0.5rem", marginBottom: "1.5rem", marginTop: "0.5rem" }}>
                                    {availableSlots?.map((slot, index) =>{
                                    let time;
                                    let localTime;
                                    if(slot?.status === "busy-reserved"){
                                        localTime = moment(slot?.start).format("HH:mm");
                                    }else{
                                        //time=`${moment(formik?.values?.date)?.format("YYYY-MM-DD")}T${(slot?.start)}:00Z`;
                                        localTime = moment(slot?.start).format("HH:mm");
                                    }
                                    return (<Col sm={2} className="slotStyle" key={index} onClick={() => { formik?.setFieldValue("availableSlot", slot); }}>{localTime}</Col>)})
                                    }
                                </Row>
                            </>
                            : null}
                        {slotsLoading ?
                            <>
                                <Row>
                                    <Col>Select Slot</Col>
                                </Row>
                                <Skeleton height={50} />
                            </>
                            : null}
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
}
